<script lang="ts">
	import { onMount } from 'svelte';
	import { t } from 'svelte-i18n';
	import Banner from '$lib/components/Banner.svelte';
	import { afterUpdate } from 'svelte';
	import type { BannerOptions } from '$lib/types/props';
	import {
		pageSpecificCMSBannerOptions,
		bannersHeight,
		isBannersHidden
	} from '@app/stores/banners';
	import CMSBanner from '@app/components/cms/CMSBanner.svelte';
	import { richTextToHTML } from '@app/utils/cms';
	import Cookies from 'js-cookie';

	let globalCMSBannerOptions: BannerOptions;
	let offlineBannerOptions: BannerOptions | undefined;
	let outdatedBrowserBannerOptions: BannerOptions;
	let bannersCtnHeight: number;

	afterUpdate(() => {
		$bannersHeight = bannersCtnHeight;
	});

	const openOfflineBanner = () => {
		offlineBannerOptions = {
			iconName: 'offline_bolt',
			message: $t('offlineMessage'),
			iconColor: 'primary'
		};
	};

	const detectOldBrowsers = () => {
		let ua = window.navigator.userAgent;
		let isIE10 = ua.indexOf('MSIE ') > 0;
		let isIE11 = ua.indexOf('Trident/') > 0;
		let isEdge = ua.indexOf('Edge/') > 0;
		let isSafari = ua.indexOf('Safari') != -1 && ua.indexOf('Chrome') === -1;
		let safariVersion;

		if (isSafari) {
			if (ua.indexOf('Version') != -1) {
				safariVersion = ua.split('Version/')[1].substring(0, 2);
			}
		}

		if (isIE10 || isIE11 || isEdge || parseFloat(safariVersion) <= 13) {
			outdatedBrowserBannerOptions = {
				iconName: 'info',
				message: $t('outdatedBrowserMessage'),
				ctaLabel: $t('reminder.labels.cni.update'),
				ctaUrl: 'https://browsehappy.com',
				color: 'warning-light',
				textColor: 'warning',
				iconColor: 'warning',
				ctaColor: 'warning'
			};
		}
	};

	onMount(async () => {
		try {
			const res = await fetch('/cms/banner');
			if (res.ok) {
				const json = await res.json();
				globalCMSBannerOptions = json.content;
				globalCMSBannerOptions.message = richTextToHTML(globalCMSBannerOptions.message);
			}
		} catch (e) {
			console.error(e);
		}

		if (!window.navigator.onLine) {
			openOfflineBanner();
		}
		window.addEventListener('offline', function () {
			openOfflineBanner();
		});
		window.addEventListener('online', function () {
			offlineBannerOptions = undefined;
		});
		detectOldBrowsers();
	});
</script>

{#if !$isBannersHidden}
	<div bind:clientHeight={bannersCtnHeight} class="sticky top-0 w-[100%] z-[11]">
		{#if $pageSpecificCMSBannerOptions?.isOpen && !Cookies.get('ws-close-cms-banner')}
			<CMSBanner props={$pageSpecificCMSBannerOptions} />
		{/if}
		{#if globalCMSBannerOptions?.isOpen && !Cookies.get('ws-close-cms-banner')}
			<CMSBanner props={globalCMSBannerOptions} />
		{/if}
		{#if offlineBannerOptions}
			<Banner props={offlineBannerOptions} />
		{/if}
		{#if outdatedBrowserBannerOptions}
			<Banner props={outdatedBrowserBannerOptions} />
		{/if}
	</div>
{/if}
